import { createSlice } from "@reduxjs/toolkit";
import {
  ConfirmModel,
  GlobalValueState,
  ToastModel,
} from "./global-value.models";

export const globalValueSlice = createSlice({
  name: "globalValue",
  initialState: {
    isLoading: false,
    activeMenu: "",
    toast: {
      duration: 3000,
    } as ToastModel,
    confirm: {
      onClose: () => {},
      onYes: () => {},
      isModal: false,
      message: "",
    } as ConfirmModel,
  } as GlobalValueState,
  reducers: {
    setLoading(state, action: { payload: boolean }) {
      state.isLoading = action.payload;
    },
    setToast(state, action: { payload: ToastModel }) {
      state.toast = action.payload;
    },
    showSuccess(state, action: { payload: string }) {
      state.toast = {
        ...state.toast,
        message: action.payload,
        status: "success",
        isShowToast: true,
      };
    },
    showError(state, action: { payload: string }) {
      state.toast = {
        ...state.toast,
        message: action.payload,
        status: "error",
        isShowToast: true,
      };
    },
    showWarning(state, action: { payload: string }) {
      state.toast = {
        ...state.toast,
        message: action.payload,
        status: "warning",
        isShowToast: true,
      };
    },
    showInfo(state, action: { payload: string }) {
      state.toast = {
        ...state.toast,
        message: action.payload,
        status: "info",
        isShowToast: true,
      };
    },
    showConfirmModal(state, action: { payload: ConfirmModel }) {
      state.confirm = {
        ...state.confirm,
        onClose: action.payload.onClose,
        onYes: action.payload.onYes,
        isModal: action.payload.isModal,
        message: action.payload.message,
      } as ConfirmModel;
    },
  },
});

export const {
  setLoading,
  setToast,
  showConfirmModal,
  showError,
  showInfo,
  showSuccess,
  showWarning,
} = globalValueSlice.actions;
